<template>
  <div>
    <v-card
      rounded="lg"
      class="px-3 py-2 hoverable-card"
      outlined
    >
      <v-row
        no-gutters
        :style="[ editable ? { minHeight: '30px' } : undefined ]"
        align="center"
      >
        <v-col
          v-if="orderable"
          cols="auto"
          class="pr-3"
        >
          <v-icon
            small
            class="handle"
            style="cursor: move"
          >
            far fa-grip-lines
          </v-icon>
        </v-col>
        <v-col>
          <div
            class="font-weight-medium"
            :class="{ 'caption': dense }"
          >
            {{ $t('training_builder.superset') }} - <strong>x{{ item.params.NMSR }}</strong>
          </div>
        </v-col>
        <v-col
          v-if="editable"
          cols="auto"
          class="show-hover"
        >
          <v-btn
            text
            color="grey darken-2"
            small
            outlined
            class="text-none"
            @click="dialog = true"
          >
            <v-icon
              x-small
              left
            >
              far fa-pen
            </v-icon>
            {{ $t('training_builder.button.parameters') }}
          </v-btn>
          <v-btn
            text
            color="error"
            small
            @click="$emit('delete')"
          >
            <v-icon x-small>
              far fa-trash
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <div style="position: relative">
        <div
          v-if="!item.exercises || item.exercises.length === 0"
          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10"
          class="grey--text"
        >
          {{ $t('training_builder.drag_exercises.box.placeholder') }}
        </div>

        <draggable
          :list="item.exercises"
          handle=".handle"
          :group="{ name: 'exercises' }"
          class="mt-2"
          :class="{ 'grey lighten-3 rounded-lg drop-placeholder': item.exercises.length === 0}"
          style="min-height: 80px; position: relative"
          :invert-swap="true"
          :swap-treshold="0.6"
          :animation="100"
          :force-fallback="true"
          belongs-to="superset"
        >
          <div
            v-for="ex in item.exercises"
            :key="ex.internal_id"
            class="mb-2"
          >
            <pause-selected-card
              v-if="ex.type === 'pause'"
              :item.sync="ex"
              :dense="dense"
              :orderable="orderable"
              :editable="editable"
              :feedback-allowed="feedbackAllowed"
              :show-media="showMedia"
              @delete="item.exercises.splice(item.exercises.findIndex(e => e.internal_id === ex.internal_id), 1)"
            />
            <exercise-selected-card-template
              v-else-if="ex.group"
              :exercise="ex"
              style="z-index: 20; position: relative"
              :dense="dense"
              :orderable="orderable"
              :editable="editable"
              :feedback-allowed="feedbackAllowed"
              :show-media="showMedia"
              :force-sets="Number(item.params.NMSR)"
              :history-allowed="historyAllowed"
              :player="player"
              :players="players"
              @delete="item.exercises.splice(item.exercises.findIndex(e => e.internal_id === ex.internal_id), 1)"
              @feedback="$emit('feedback', $event)"
            />
          </div>
        </draggable>
      </div>

      <validation-provider
        v-slot="{ errors }"
        rules="required"
      >
        <input
          type="hidden"
          :value="item.exercises.length > 0 ? true : undefined"
        >
        <div
          v-if="errors.length > 0"
          class="error--text mt-2 mb-1 text-body-1"
        >
          {{ $t("training_builder.exercise_required") }}
        </div>
      </validation-provider>
    </v-card>

    <card-dialog
      v-model="dialog"
      max-width="600px"
      :title="$t('training_builder.configure_superset.dialog.header')"
    >
      <v-card-text
        class="pa-6"
      >
        <v-text-field
          v-model="params.NMSR"
          outlined
          :label="$t('training_builder.text_input.number_of_sets.title')"
          type="number"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="saveParams()"
        >
          {{ $t('training_builder.button.save') }}
        </v-btn>
      </v-card-actions>
    </card-dialog>
  </div>
</template>
<script>
import CardDialog from '@/components/helpers/CardDialog.vue'
import draggable from 'vuedraggable'
import PauseSelectedCard from '@/components/training-builder/PauseSelectedCard.vue'
import ExerciseSelectedCardTemplate from '@/components/training-builder/ExerciseSelectedCardTemplate.vue'

export default {
  name: 'SupersetSelectedCard',
  components: { ExerciseSelectedCardTemplate, PauseSelectedCard, CardDialog, draggable },
  props: {
    item: {
      type: Object,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    orderable: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    feedbackAllowed: {
      type: Boolean,
      default: false
    },
    showMedia: {
      type: Boolean,
      default: false
    },
    historyAllowed: {
      type: Boolean,
      default: false
    },
    player: {
      type: Object,
      default: () => undefined
    },
    players: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      dialog: false,
      params: {
        NMSR: 2
      }
    }
  },

  computed: {
  },

  created() {
    if (!this.item.params) {
      this.item.params = { ...this.params }
    } else if (this.item.params) {
      this.params = { ...this.item.params }
    }

    if (this.item.configureParams) {
      this.dialog = true
      this.item.configureParams = false
    }
  },

  methods: {
    saveParams() {
      this.item.params = JSON.parse(JSON.stringify(this.params))

      this.dialog = false
    }
  }
}
</script>
